module.exports = __webpack_public_path__ + "static/06-82531bda948c37677fd6dc9579e62d30.jpg";